import type React from 'react';

import { Badge, Button, ChangeDot, Text } from '@change/ds-core-ui';

import { Translate, TypedTranslate } from '@change-corgi/core-react/i18n';

import { PLAN_ROWS } from './consts';

/** An illustration of a campaign assistant conversation; nothing in it is interactive. */
export const MockChatCard: React.FC<EmptyProps> = () => {
	return (
		<div
			className="border-stroke-weaker bg-background-base elevation-elevated overflow-hidden rounded-2xl border"
			data-qa="vision-copilot-card"
		>
			<div
				className="border-stroke-weaker flex items-center gap-2.5 border-b px-5 py-4"
				data-qa="vision-copilot-card-header"
			>
				<ChangeDot size="small" />
				<Text size="small" fontWeight="bold">
					<Translate value="corgi.vision_page.copilot.card.label" />
				</Text>
			</div>
			<div className="flex flex-col gap-4 p-5">
				<Text
					as="p"
					size="small"
					className="bg-background-raised max-w-4/5 self-end rounded-2xl rounded-br-sm px-4 py-3"
					data-qa="vision-copilot-bubble"
				>
					<Translate value="corgi.vision_page.copilot.card.user_message" />
				</Text>
				<Text size="small">
					<Translate value="corgi.vision_page.copilot.card.assistant_message" />
				</Text>
				<div className="border-stroke-weaker overflow-hidden rounded-lg border" data-qa="vision-copilot-plan">
					{PLAN_ROWS.map(({ id, label, value }, index) => (
						<div
							key={id}
							className="border-stroke-weaker flex items-start gap-3 border-b px-3.5 py-3 last:border-b-0"
							data-qa="vision-copilot-plan-row"
						>
							{/* a plain numeric label: the server render rejects localizeNumber */}
							<Badge
								label={index + 1}
								size="small"
								variant="information"
								emphasis="strong"
								className="w-6 justify-center px-0"
							/>
							<div className="flex flex-col gap-0.5">
								<Text size="x-small" fontWeight="bold" className="text-typography-weak uppercase">
									<TypedTranslate value={label} />
								</Text>
								<Text size="small">
									<TypedTranslate value={value} />
								</Text>
							</div>
						</div>
					))}
				</div>
				<div className="flex flex-wrap gap-2.5">
					<Button as="span" variant="primary" size="small" data-qa="vision-copilot-use-plan">
						<Translate value="corgi.vision_page.copilot.card.use_plan" />
					</Button>
					<Button as="span" variant="secondary" size="small" data-qa="vision-copilot-edit">
						<Translate value="corgi.vision_page.copilot.card.edit" />
					</Button>
				</div>
			</div>
		</div>
	);
};
